export default __webpack_public_path__ + "80f0e0a431801ce11d8fb854c760f209.png";